import React, { createContext, useContext, useState, useCallback } from "react";

const CompareContext = createContext(null);

const MAX_COMPARE_ITEMS = 4;

export function CompareProvider({ children }) {
  const [compareItems, setCompareItems] = useState([]);

  const addItem = useCallback((item) => {
    setCompareItems((prev) => {
      if (prev.length >= MAX_COMPARE_ITEMS) return prev;
      if (prev.some((i) => i.uri === item.uri)) return prev;
      return [...prev, item];
    });
  }, []);

  const removeItem = useCallback((uri) => {
    setCompareItems((prev) => prev.filter((i) => i.uri !== uri));
  }, []);

  const toggleItem = useCallback((item) => {
    setCompareItems((prev) => {
      const exists = prev.some((i) => i.uri === item.uri);
      if (exists) return prev.filter((i) => i.uri !== item.uri);
      if (prev.length >= MAX_COMPARE_ITEMS) return prev;
      return [...prev, item];
    });
  }, []);

  const clearAll = useCallback(() => {
    setCompareItems([]);
  }, []);

  const isSelected = useCallback(
    (uri) => compareItems.some((i) => i.uri === uri),
    [compareItems]
  );

  const isFull = compareItems.length >= MAX_COMPARE_ITEMS;

  return (
    <CompareContext.Provider
      value={{
        compareItems,
        addItem,
        removeItem,
        toggleItem,
        clearAll,
        isSelected,
        isFull,
        maxItems: MAX_COMPARE_ITEMS,
      }}
    >
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error("useCompare must be used within a CompareProvider");
  }
  return context;
}
